import { gql } from 'graphql-request'

export const query_sessionCheck = gql`
  query logout_sessionCheck {
    org_sessionCheck {
      isSessionValid
    }
  }
`
